import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import { useEventsApi } from 'services/api/hooks/useEventsApi.hook';
import { FeedbackFormData } from '../constants';

export const useFeedbackSubmission = (
  eventId: string,
  hasSubmitted: boolean,
  onClose: () => void,
) => {
  const router = useRouter();
  const eventsApi = useEventsApi();
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    // Check if we came from notification drawer
    const fromNotification = router.query.fromNotification === 'true';

    // Remove feedback and fromNotification query params when closing
    const { feedback, fromNotification: _, ...restQuery } = router.query;
    void router.replace(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true },
    );

    // If we came from notification drawer, don't call onClose
    // This keeps the notification drawer open
    if (!fromNotification)
      onClose();

  };

  const onSubmit = async (data: FeedbackFormData) => {
    if (hasSubmitted) {
      enqueueSnackbar('You have already submitted feedback for this event.', {
        variant: 'info',
      });
      return;
    }

    const result = await eventsApi.submitEventFeedback(
      eventId,
      data.rating,
      data.selectedQuestionIds,
      data.comment,
    );

    if (!result.success) {
      enqueueSnackbar(result.error.message || 'Failed to submit feedback', {
        variant: 'error',
      });
      return;
    }

    enqueueSnackbar('Thank you for your feedback!', {
      variant: 'success',
    });

    // Check if we came from notification drawer
    const fromNotification = router.query.fromNotification === 'true';

    // Close drawer and remove query params
    const { feedback, fromNotification: _, ...restQuery } = router.query;
    void router.replace(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true },
    );

    // If we came from notification drawer, don't call onClose
    // This keeps the notification drawer open
    if (!fromNotification)
      onClose();

  };

  return {
    onSubmit,
    handleClose,
  };
};

